
import {
  Routes,
  Route,
  useNavigate,
  useLocation,
} from 'react-router-dom';

import { ToastContainer } from 'react-toastify';

import Login from './pages/loginui';
import MapAreaUI from './pages/mapareaui';
import Logout from './pages/logoutcomp';
import TrackerUI from "./pages/trackerui";
import TeamUI from "./pages/teamui";
import ReportUI from './pages/reportui';
import SettingUI from './pages/setting';
import SignupUi from './pages/signupui';
import {APPRoute} from './component/texts'; 
import OTPUI from './pages/otpui';
import ForgotPasswd from './pages/forgot_passwd';
import ResetPasswd from './pages/reset_password';
import CustomerUI from './pages/customers'; 
import DriverUI from './pages/agents';
import PriceEstimateUI from './pages/price_estimates'; 
import PackageUI from './pages/packages';
import ShipmentReportUI from './pages/shipment_report';



function App() {

  const navigate = useNavigate(); 
  const location = useLocation();


  return (
    <div className="container-fluid">
      <div className="row">
        <div className='col-md-12'>
          <ToastContainer />
          <Routes>
          
            <Route path={APPRoute.shipment_reports} element={<ShipmentReportUI location={location} navigate={navigate}/>} />            
            <Route path={APPRoute.packages} element={<PackageUI location={location} navigate={navigate}/>} />
            <Route path={APPRoute.price_estimate} element={<PriceEstimateUI location={location} navigate={navigate}/>} />
            <Route path={APPRoute.agents} element={<DriverUI location={location} navigate={navigate} />} />
            <Route path={APPRoute.password_confirm} element={<ForgotPasswd navigate={navigate} />} />
            <Route path={APPRoute.password_reset} element={<ResetPasswd location={location} navigate={navigate} />} />
            <Route path={APPRoute.customer} element={<CustomerUI location={location} navigate={navigate} />} />
            <Route path={APPRoute.logout} element={<Logout navigate={navigate} />} />
            <Route path={APPRoute.device} element={<TrackerUI />} />
            <Route path={APPRoute.otp} element={<OTPUI location={location} navigate={navigate} />} />
            <Route path={APPRoute.map} element={<MapAreaUI />} />
            <Route path={APPRoute.team} element={<TeamUI />} />
            <Route path={APPRoute.report} element={<ReportUI />} />
            <Route path={APPRoute.settings} element={<SettingUI  />} />
            <Route path={APPRoute.signup} element={<SignupUi navigate={navigate} />} />
            <Route path={APPRoute.login} element={<Login navigate={navigate} />} />
            
          </Routes>
        </div>
      </div>

    </div>
  );
}

export default App;

